import React, { FC } from 'react';
import TouchableElement from '@components/common/touchableElement';
import { View } from 'react-native';
import { PictureProps } from '@v2/components/imageHandling/components/Picture';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { isWeb } from '@helpers';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { ImageDocumentStoreItem, PageChangeActionType } from '@v2/components/imageHandling/types/types.d';
import { usePictureContext } from '@v2/components/imageHandling/providers/PictureProvider/usePictureContext';
import { changePDFImage } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

interface PagesNavigationArrowProps extends Pick<PictureProps, 'scale' | 'C'> {
  pageChangeActionType: PageChangeActionType;
  image: ImageDocumentStoreItem;
}

const PagesNavigationArrow: FC<PagesNavigationArrowProps> = ({ pageChangeActionType, image, C, scale = initialScale }) => {
  const dispatch = useAppDispatch();
  const { imageContextKey } = usePictureContext();

  const isNextPageAction = pageChangeActionType === PageChangeActionType.NEXT;

  return (
    <TouchableElement
      onPress={() => {
        if (isNextPageAction && image?.pageCount === image?.pageNumber) {
          return;
        }
        if (!isNextPageAction && image?.pageNumber === 1) {
          return;
        }
        dispatch(changePDFImage({ contextKey: imageContextKey, contentHash: image.contentHash, pageChangeActionType, documentId: image.documentId }));
      }}
    >
      {({ boxStyle, pressHoverColor }) => (
        <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
          <View
            style={[
              boxStyle,
              {
                width: scale(36),
                height: scale(36),
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: C(pressHoverColor('Button/Light/On Picture')),
                borderRadius: scale(36) / 2,
                shadowColor: C('Shadow / Light / Narrow'),
                shadowOffset: {
                  width: 0,
                  height: 1,
                },
                shadowOpacity: 0.15,
                shadowRadius: 2.22,
                elevation: 3,
              },
            ]}
          >
            <Svg icon="arrow" color="Label/Light/AlwaysLight Primary" width={scale(20)} height={scale(isWeb ? 15 : 20)} />
          </View>
        </View>
      )}
    </TouchableElement>
  );
};

export { PagesNavigationArrow };
